var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "12px",
    height: "12px",
    fill: "#5C6068",
    viewBox: "0 0 12 12",
    style: {
      cursor: "pointer"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6972_490)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2.571,
    width: 9.429,
    height: 9.429,
    rx: 2.571
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.713 1.728c.094-.01.19-.014.287-.014h4.286a3 3 0 013 3V9c0 .097-.005.193-.014.287A2.572 2.572 0 0012 6.857V2.571A2.571 2.571 0 009.429 0H5.143c-1.125 0-2.08.722-2.43 1.728z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6972_490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3a1792e4152ad723cbf73f03aa58280b.svg";
export { ForwardRef as ReactComponent };